import { gql } from 'graphql-request'

const getMenusWithArea = gql`
  query getMenusWithArea($area: [Area!], $lang: [Locale!]!) {
    sectionMenus(where: { area_contains_some: $area }, locales: $lang) {
      id
      area
      label
      menuText
      menuIcon
      image {
        url(transformation: { document: { output: { format: webp } } })
      }
      menuItems {
        ... on Link {
          id
          url
          title
          linkType: type
          type: __typename
          icon
          linkTarget
        }
        ... on Page {
          id
          url: slug
          title
          type: __typename
          icon
        }
        ... on ArticleTopic {
          id
          title
          url: slug
          type: __typename
        }
      }
      subMenu {
        ... on Link {
          id
          url
          title
          linkType: type
        }
        ... on Page {
          id
          url: slug
          title
          type: __typename
        }
        ... on ArticleTopic {
          id
          title
          url: slug
          type: __typename
        }
      }
      page {
        slug
        themeColor
        title
      }
      priority
      menuItemWithSubMenu {
        ... on MenuItemWithSubMenu {
          id
          menuItem {
            ... on Link {
              id
              url
              title
              linkType: type
              type: __typename
              icon
              linkTarget
            }
            ... on Page {
              id
              url: slug
              title
              type: __typename
            }
            ... on ArticleTopic {
              id
              title
              url: slug
              type: __typename
            }
          }
          subMenuItem {
            ... on Link {
              id
              url
              title
              linkType: type
              type: __typename
              icon
              linkTarget
            }
            ... on Page {
              id
              url: slug
              title
              type: __typename
            }
            ... on ArticleTopic {
              id
              title
              url: slug
              type: __typename
            }
          }
          image {
            url(transformation: { document: { output: { format: webp } } })
          }
        }
      }
    }
  }
`
export default getMenusWithArea
